import { useMutation } from 'react-query'

import { useUmbrella } from '@modules-deprecated/app/umbrellas'

import { APIError } from '../../../../../utils'
import {
  createUmbrellaSubscriptions,
  CreateUmbrellaSubscriptionsPayload,
  CreateUmbrellaSubscriptionsResponse,
} from '../query-api'

interface UseAddPaymentMethodArgs {
  onError?: (error: APIError) => void
  onSuccess?: (response: CreateUmbrellaSubscriptionsResponse) => void
}

export const useAddPaymentMethod = ({ onError, onSuccess }: UseAddPaymentMethodArgs = {}) => {
  const { umbrella } = useUmbrella()
  const { mutate: create, isLoading } = useMutation(
    (payload: CreateUmbrellaSubscriptionsPayload) => createUmbrellaSubscriptions(umbrella?.id as string, payload),
    { onError, onSuccess },
  )

  return {
    create,
    isLoading,
  }
}
